<header class="header-page">
  <h1 class="col-7 px-0 header__page__content__title">
    Minhas adesões
  </h1>
  <div class="col-5 px-1">
    <a type="button" [routerLink]="['/adesao-saude']" class="btn btn-outline-primary float-right">
      <span>Voltar</span>
    </a>
  </div>
</header>
<ng-template #naoPossuiAdesoes>
  <p class="col-12 mt-6 text-center">Você não possui adesões</p>
</ng-template>
<main class="col-xl-12 px-2 main__content">
  <p class="desc_card">
    Caso queira excluir algum dependente, você pode acessar a tela de <a [routerLink]="['/cancelar']">Excluir Dependente
      do Plano</a>
  </p>
  <section class="content-adesoes" *ngIf="listaAdesoes && listaAdesoes.length > 0; else naoPossuiAdesoes">
    <div class="px-2 mt-1" *ngFor="let item of listaAdesoes; let i = index">
      <div class="guia col-12 row">
        <div class="col-lg-2 col-sm-12  px-2 pr-md-3">
          <div class="tag">
            <span>Nome do Dependente</span>
          </div>
          <div class="informacao">
            <span>{{item.nomeDependente}}</span>
          </div>
        </div>
        <div class="col-lg-3 col-sm-12  px-2 pr-md-3">
          <div class="tag">
            <span>Data e hora da solicitação</span>
          </div>
          <div class="text-center informacao">
            <span *ngIf="item.dataSolicitacao != null">{{item.dataSolicitacao | date:'dd/MM/yyyy HH:mm'}}</span>
            <span *ngIf="item.dataSolicitacao == null"> - </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>